export default [
  {
    path: '/driver-center',
    meta: { title: '司机管理中心' },
    component: () =>
      import(
        /* webpackChunkName: "erp-returns-edit" */ '@/pages/agent/erp/driver-center/index.vue'
      ),
  },
]
